<!--
 * @Author: zhaoyian zhaopeng1957462481@163.com
 * @Date: 2023-11-09 20:04:03
 * @LastEditors: zhaoyian zhaopeng1957462481@163.com
 * @LastEditTime: 2023-11-15 18:58:27
 * @FilePath: \yunque\src\layout\components\head.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
<el-affix position="top" offset @scroll="useScroll">
    <div class="head">
        <div class="head_left">
            <div class="logo">
                <img src="../../assets/images/logo3.png" alt="" srcset="">
            </div>
            <!-- <span>Meixi | AI</span> -->
        </div>
        <div class="head_right">
            <!-- <span class="action">美溪开放平台</span>
            <span class="action">帮助中心</span> -->
            <span class="action" @click="goMx">登录</span>
        </div>
        <!-- <HomeForm :dialogFormVisible="dialogFormVisible" @FormOut="FormOut" @FormSubmit="FormSubmit"></HomeForm> -->
    </div>
</el-affix>
      <HomeForm :dialogFormVisible="dialogFormVisible" @FormOut="FormOut" @FormSubmit="FormSubmit"></HomeForm>
</template>
<script>
import HomeForm from '../../components/HomeForm'

export default {
    name: 'headPage',
    components: {
        HomeForm,
    },
    data() {
        return {
            dialogFormVisible: false,
        }
    },

    created() {

    },
    mounted() {

    },
    methods: {
        goMx() {
            window.open('https://marketing.yunquetech.com/')
        },
        useGoMx() {
            this.dialogFormVisible = true
        },
        FormOut() {
            this.dialogFormVisible = false
        },
        FormSubmit(){ 
            this.dialogFormVisible = false
        },
        useScroll(scrollTop) {
           
        }
    }
}
</script>
<style lang="less" scoped>
.head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(80, 91, 255, 1);
    // height: 100rem;
    height: 52rem;
    // margin-top: 14rem;
    background: white;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    padding: 14rem 50rem;

    .head_left {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 28rem;

        .logo {
            width: 160rem;
            // width: 50rem;
            height: 39rem;
            display: inline-block;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .head_right {
        display: flex;
        align-items: center;

        .action {
            margin-right: 30rem;
            cursor: pointer;
        }

        .use_button {
            width: 130rem;
            height: 40rem;
            border-radius: 30rem;
            text-align: center;
            line-height: 40rem;
            background: rgba(80, 91, 255, 1);
            font-size: 16rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer;
        }
    }
}
</style>